import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/** Names the browser tab after the page ("Projects · ESI"), as assistive technology announces. */
export function useDocumentTitle(title: string | null | undefined, enabled = true) {
  const { t } = useTranslation();
  const app = t("app.name");
  useEffect(() => {
    if (enabled) {
      document.title = title ? `${title} · ${app}` : app;
    }
  }, [title, app, enabled]);
}
